<template>
  <div class="loading-screen">
    <div class="loading-content">
      <img
        :src=LogoPath
        alt="Logo"
        class="loading-logo"
      />
      <div class="loading-progress">
        <ProgressBar
          mode="indeterminate"
          class="progress-bar"
        />
      </div>
      <div class="loading-text">
        Загрузка приложения...
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressBar from 'primevue/progressbar';
import LogoPath from '@/common/constants/logo';
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: opacity 0.3s ease;
}

.loading-content {
  text-align: center;
  animation: fadeIn 0.5s ease;
}

.loading-logo {
  width: 120px;
  height: 120px;
  margin-bottom: 2rem;
  animation: pulse 1.5s ease-in-out infinite;
}

.loading-progress {
  width: 200px;
  margin: 0 auto 1rem;
}

.progress-bar {
  --p-progressbar-height: 0.5rem;
  border-radius: 2px;
}

.loading-text {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

@keyframes pulse {
  0% { opacity: 0.8; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.8; transform: scale(0.95); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
